<template>
	<div>
		列表
	</div>
</template>
<script>
	module.exports=require('./List.js');
</script>


// WEBPACK FOOTER //
// List.vue?31ccb5e0